module.exports = __webpack_public_path__ + "media/matches/filter-923f89bc.svg";